export const CONTACT_PHOTO_REJECT_REASONS = [
   'Not true likeness',
   'Not a head and shoulder pic',
   'Unclear/blurry pic',
   'Other',
];
